// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22mKD","controls":"styles_controls__3qZ9o","charLimit":"styles_charLimit__1vUZu","input":"styles_input__2_h_I","send":"styles_send__25O3M"};